import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import axios from "axios";
import Login from "@/components/Login";
import Dashboard from "@/components/Dashboard";
import Clientes from "@/components/Clientes";
import Medicamentos from "@/components/Medicamentos";
import Inscripciones from "@/components/Inscripciones";
import Notificaciones from "@/components/Notificaciones";
import Usuarios from "@/components/Usuarios";
import ConfigERP from "@/components/ConfigERP";
import Reportes from "@/components/Reportes";
import CarnetVIP from "@/components/CarnetVIP";
import CarnetPublico from "@/components/CarnetPublico";
import Layout from "@/components/Layout";
import RegistroPublico from "@/components/RegistroPublico";
import { Toaster } from "@/components/ui/sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) setIsAuthenticated(true);
    setLoading(false);
  }, []);

  const handleLogin = (token) => {
    localStorage.setItem("token", token);
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    setIsAuthenticated(false);
  };

  if (loading) {
    return <div className="flex items-center justify-center h-screen">Cargando...</div>;
  }

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<RegistroPublico />} />
          <Route path="/registro" element={<RegistroPublico />} />
          <Route path="/carnet/:serie" element={<CarnetPublico />} />
          <Route
            path="/login"
            element={isAuthenticated ? <Navigate to="/admin" replace /> : <Login onLogin={handleLogin} />}
          />
          <Route
            path="/admin"
            element={isAuthenticated ? <Layout onLogout={handleLogout} /> : <Navigate to="/login" replace />}
          >
            <Route index element={<Dashboard />} />
            <Route path="clientes" element={<Clientes />} />
            <Route path="medicamentos" element={<Medicamentos />} />
            <Route path="inscripciones" element={<Inscripciones />} />
            <Route path="notificaciones" element={<Notificaciones />} />
            <Route path="reportes" element={<Reportes />} />
            <Route path="vip" element={<CarnetVIP />} />
            <Route path="usuarios" element={<Usuarios />} />
            <Route path="erp" element={<ConfigERP />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
export { API };
